import AnchorLink from 'react-anchor-link-smooth-scroll';

const MenuStyled = ({ open }) => (
  <div>
    {open ? (
      <div class="z-50 transition ease-out duration-75 absolute mt-2 w-48 -ml-36 md:-ml-16 shadow-lg">
        <div
          class="rounded-lg bg-white shadow-xs"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
        >
          <div class="rounded-lg pb-3 pt-3">
            <a
              href="http://georgia.kratosgp.com/"
              target="_blank"
              class="block px-4 py-4 text-sm leading-5 text-gray-700 font-semibold hover:bg-fadedBlue hover:pl-8 hover:text-blue focus:outline-none focus:bg-gray-100 focus:text-gray-900"
              role="menuitem"
            >
              Georgia
            </a>
            <a
              href="https://michigan.kratosgp.com/"
              target="_blank"
              class="block px-4 py-4 text-sm leading-5 text-gray-700 font-semibold hover:bg-fadedBlue hover:pl-8 hover:text-blue focus:outline-none focus:bg-gray-100 focus:text-gray-900"
              role="menuitem"
            >
              Michigan
            </a>
          </div>
          <div class="border-t border-gray-100"></div>
          <div class="pb-3">
            <a
              href="/about"
              class="block px-4 py-4 text-sm leading-5 text-gray-600 hover:bg-fadedBlue hover:pl-8 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
              role="menuitem"
            >
              About
            </a>
            <a
              href="/support"
              class="block px-4 py-4 text-sm leading-5 text-gray-600 hover:bg-fadedBlue hover:pl-8 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
              role="menuitem"
            >
              Support
            </a>
            <a
              href="/blog"
              class="block px-4 py-4 text-sm leading-5 text-gray-600 hover:bg-fadedBlue hover:pl-8 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
              role="menuitem"
            >
              Blog
            </a>
            <a
              href="https://ugecredits.com/"
              className="block px-4 py-4 text-sm leading-5 text-gray-600 hover:bg-fadedBlue hover:pl-8 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
            >
              Offsets
            </a>
            <a
              href="/support/"
              className="block px-4 py-4 text-sm leading-5 text-gray-600 hover:bg-fadedBlue hover:pl-8 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
            >
              FAQ
            </a>
            <a
              href="/terms/"
              className="block px-4 py-4 text-sm leading-5 text-gray-600 hover:bg-fadedBlue hover:pl-8 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
            >
              Terms
            </a>
            <a
              href="/certificates-labels/"
              className="block px-4 py-4 text-sm leading-5 text-gray-600 hover:bg-fadedBlue hover:pl-8 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
            >
              Green-E
            </a>
            <div class="border-t border-gray-100"></div>
            <div class="flex items-center mt-2 px-4 py-4 ">
              <a href="tel:800-296-2203" role="menuitem">
                <svg
                  class="mr-3 h-6 w-6 text-blue hover:text-gray-500 "
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </a>
              <a href="mailto:Hello@kratosgp.com" role="menuitem">
                <svg
                  class="ml-3 h-6 w-6 text-blue hover:text-gray-500 "
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 12.713l-11.985-9.713h23.971l-11.986 9.713zm-5.425-1.822l-6.575-5.329v12.501l6.575-7.172zm10.85 0l6.575 7.172v-12.501l-6.575 5.329zm-1.557 1.261l-3.868 3.135-3.868-3.135-8.11 8.848h23.956l-8.11-8.848z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div class="z-50  hidden opacity-0 scale-95 transition ease-in duration-75 absolute mt-2 w-48 -ml-36 md:-ml-16 shadow-lg">
        <div
          class="rounded-lg bg-white shadow-xs"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
        >
          <div class="rounded-lg pb-3 pt-3 bg-gray-50">
            <h4
              href="#"
              class="block px-4 py-4 text-sm leading-5 text-gray-700 font-semibold hover:bg-fadedBlue hover:pl-8 hover:text-blue focus:outline-none focus:bg-gray-100 focus:text-gray-900 pointer-events-none"
              role="menuitem"
            >
              Georgia
            </h4>
            <h4
              href="#"
              class="block px-4 py-4 text-sm leading-5 text-gray-700 font-semibold hover:bg-fadedBlue hover:pl-8 hover:text-blue focus:outline-none focus:bg-gray-100 focus:text-gray-900 pointer-events-none"
              role="menuitem"
            >
              Michigan
            </h4>
          </div>
          <div class="border-t border-gray-100"></div>
          <div class="pb-3">
            <h4
              href="#"
              class="block px-4 py-4 text-sm leading-5 text-gray-700  hover:bg-fadedBlue hover:pl-8 hover:text-blue focus:outline-none focus:bg-gray-100 focus:text-gray-900 pointer-events-none"
              role="menuitem"
            >
              About
            </h4>
            <h4
              href="#"
              class="block px-4 py-4 text-sm leading-5 text-gray-700  hover:bg-fadedBlue hover:pl-8 hover:text-blue focus:outline-none focus:bg-gray-100 focus:text-gray-900 pointer-events-none"
              role="menuitem"
            >
              Support
            </h4>
            <h4
              href="#"
              class="block px-4 py-4 text-sm leading-5 text-gray-700  hover:bg-fadedBlue hover:pl-8 hover:text-blue focus:outline-none focus:bg-gray-100 focus:text-gray-900 pointer-events-none"
              role="menuitem"
            >
              FAQ
            </h4>
          </div>
        </div>
      </div>
    )}
  </div>
);

export default MenuStyled;
